<script type="text/javascript">
    
    import moment from "moment";
    import Chart from "chart.js";
    import colorLib from '@kurkle/color';

    import { onDestroy, onMount } from "svelte";

    export let title = "Chart";
    export let days = 30;
    export let data = null;

    export let keys = [];        // refers to property name in <day data>, one key for each line

    let chart = null;
    let canvas = null;

    onMount(() => {
       updateChart();
    })
    onDestroy(()=>{
		if (chart !== null) {
			chart.destroy();
			chart = null;
		}
    });
    $: {
        updateChart();
    }

    let updateChart = () => {
        // console.log("update chart", chart, canvas, data);
        if (chart === null && canvas !== null && data !== null) {
            
            let dates = [];
            let keyedData = {};
            data.sort((a, b) => {
                return moment(b.Date) - moment(a.Date);
            });
            // console.log("data", data);
            for(let i = 0; i < data.length && i < days; i++) 
            {
                let useIndex = days - 1 - i; // reverse order for graph. 
                if (typeof data[useIndex] === "undefined") {
                    continue; 
                }
                let day = data[useIndex].data;
                let date_yyyymmdd = data[useIndex].Date;
                dates.push(date_yyyymmdd);
                for(let k = 0; k < keys.length; k++) {
                    let keyName = keys[k];
                    let count = day.Graph_type[keyName];
                    if (typeof keyedData[keyName] === "undefined") {
                        keyedData[keyName] = [];
                    }
                    keyedData[keyName].push(count); 
                }
                
            }
            function transparentize(value, opacity) {
                var alpha = opacity === undefined ? 0.5 : 1 - opacity;
                return colorLib(value).alpha(alpha).rgbString();
            }

            const CHART_COLORS = {
                green: 'rgb(75, 192, 192)',
                red: 'rgb(255, 99, 132)',
                orange: 'rgb(255, 159, 64)',
                yellow: 'rgb(255, 205, 86)',
                blue: 'rgb(54, 162, 235)',
                purple: 'rgb(153, 102, 255)'
            };
            const chartData = {
                labels: dates, // Object.keys(keyedData), 
                datasets: []
            };
            for(let k = 0; k < keys.length; k++) {
                let color = CHART_COLORS[Object.keys(CHART_COLORS)[k]];
                chartData.datasets.push({
                    label: keys[k],
                    data: keyedData[keys[k]], 
                    fill: false,
                    borderColor: color,
                    backgroundColor: transparentize(color, 0.5)
                });
            }
            console.log("chartData",chartData);

            const config = {
                type: 'line',
                data: chartData,
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: title
                        }
                    }
                },
            };
            chart = new Chart(canvas.getContext("2d"), config);
        }
        if (chart !== null && canvas !== null) {
            chart.update();
        }
    };
    
</script>

<p><b>{title}</b></p>
<canvas bind:this={canvas}></canvas>    